import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseMagHeader() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();
  const { toGregorian, toSolar } = require("jdate-convert");

  function validate(state, imgState, setter) {
    let errorState = {
      title: isEmpty(state.title),
      url: isEmpty(state.url),
      file1: isEmpty(imgState.url1),
      file2: isEmpty(imgState.url2),
    };

    setter(errorState);

    if (errorState.title || errorState.url) {
      enqueueSnackbar("لطفا اطلاعات اسلاید را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetMagHeader = (callback) => {
    MyAxios.get(`Admin_Mag_HomePage/GetHeader`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const SetMagHeader = (state, Logo1, Logo2, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (Logo1) {
      data.append("Logo1", Logo1);
    }
    if (Logo2) {
      data.append("Logo2", Logo2);
    }
    MyAxios.post(`Admin_Mag_HomePage/SetHeader`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    validate,
    GetMagHeader,
    SetMagHeader,
  };
}
